// Guests come only from the booking URL: ?adults=N&children=N (per room).
export const MIN_ADULTS = 1;
export const MAX_ADULTS = 30;
export const MIN_CHILDREN = 0;
export const MAX_CHILDREN = 20;

// URL value -> whole number within [min, max]
const clampNumber = (value, min, max, fallback) => {
  const parsed = parseInt(value, 10);
  if (!Number.isFinite(parsed)) return fallback;
  return Math.min(Math.max(parsed, min), max);
};

// { adults, children } when the URL has either param, otherwise null
// (null = no guest filter, rooms keep their default occupancy)
export const readGuestParams = (search) => {
  const query = new URLSearchParams(search);
  const adultsParam = query.get("adults") || query.get("adult");
  const childrenParam = query.get("children") || query.get("child");
  if (!adultsParam && !childrenParam) return null;
  return {
    adults: clampNumber(adultsParam, MIN_ADULTS, MAX_ADULTS, MIN_ADULTS),
    children: clampNumber(
      childrenParam,
      MIN_CHILDREN,
      MAX_CHILDREN,
      MIN_CHILDREN,
    ),
  };
};

export const adultsLabel = (count) =>
  `${count} ${count === 1 ? "Adult" : "Adults"}`;
export const childrenLabel = (count) =>
  `${count} ${count === 1 ? "Child" : "Children"}`;
export const infantsLabel = (count) =>
  `${count} ${count === 1 ? "Infant" : "Infants"}`;
// "3 Adults", "2 Adults · 1 Child", "2 Adults · 1 Child · 1 Infant"
export const guestsLabel = (adults, children = 0, infants = 0) =>
  [
    adultsLabel(adults),
    children > 0 ? childrenLabel(children) : null,
    infants > 0 ? infantsLabel(infants) : null,
  ]
    .filter(Boolean)
    .join(" · ");
